var map = {
	"./alarm-busy.png": 674,
	"./alarm-offline.png": 675,
	"./alarm-online.png": 676,
	"./camera-busy.png": 677,
	"./camera-offline.png": 678,
	"./camera-online.png": 679,
	"./device-busy.png": 680,
	"./device-offline.png": 681,
	"./device-online.png": 682,
	"./staff-busy.png": 683,
	"./staff-offline.png": 684,
	"./staff-online.png": 685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 673;